module.exports = __webpack_public_path__ + "static/media/onTheOcean.e06c8752.JPG";